import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';

const bollaStyles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  title: { fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginBottom: 16 },
  section: { marginBottom: 10 },
  row: { flexDirection: 'row', marginBottom: 4 },
  label: { fontWeight: 'bold', width: 160 },
  value: { flex: 1 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#e0e0e0', padding: 4, marginBottom: 2, fontWeight: 'bold' },
  tableRow: { flexDirection: 'row', padding: 4, borderBottom: '1 solid #ccc' },
  col1: { width: '40%' },
  col2: { width: '30%' },
  col3: { width: '30%' },
  divider: { borderBottom: '1 solid #aaa', marginVertical: 8 },
  firmaImg: { width: 200, height: 80, border: '1 solid #999' },
  footerRow: { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 },
  footerCol: { width: '45%' },
  footerLabel: { fontWeight: 'bold', marginBottom: 4 },
  prestazione: { marginTop: 4, lineHeight: 1.5 },
  intestazione: { flexDirection: 'row', alignItems: 'center', marginBottom: 16, paddingBottom: 10, borderBottom: '1 solid #ccc' },
  logoImg: { width: 80, height: 32, objectFit: 'contain' },
  recapiti: { marginLeft: 12, fontSize: 9, color: '#333' },
  recapitiNome: { fontSize: 10, fontWeight: 'bold', marginBottom: 2 },
  numeroBollaBox: { marginLeft: 'auto', backgroundColor: '#1a1a1a', borderRadius: 4, paddingVertical: 6, paddingHorizontal: 12, alignItems: 'center', justifyContent: 'center' },
  numeroBollaLabel: { fontSize: 7, color: '#aaa', textTransform: 'uppercase', letterSpacing: 1 },
  numeroBollaText: { fontSize: 20, fontWeight: 'bold', color: '#ffffff' },
  page2: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  page2Title: { fontSize: 14, fontWeight: 'bold', textAlign: 'center', marginBottom: 12 },
  page2Subtitle: { fontSize: 10, color: '#555', textAlign: 'center', marginBottom: 16 },
  fotoPesataImg: { width: '100%', maxHeight: 620, objectFit: 'contain', border: '1 solid #ccc' },
  fotoPesataBox: { width: '100%', height: 300, border: '1 solid #ccc', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f5f5f5' },
  fotoPesataNone: { color: '#999', fontSize: 12 },
});

function fmtData(d) {
  if (!d) return '';
  const parts = d.split('-');
  if (parts.length !== 3) return d;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

export default function BollaPDF({ bolla }) {
  const {
    cliente, cantiere, data, mezzi = [],
    smaltimentoScavo, smaltimentoDemo,
    prestazione, nomeAutista,
    firmaUrl, fotoPesataUrl,
    nomeClienteFirma,
    numeroBolla,
  } = bolla;

  return (
    <Document>
      <Page size="A4" style={bollaStyles.page}>
        <View style={bollaStyles.intestazione}>
          <Image src="CRG_logo.png" style={bollaStyles.logoImg} />
          <View style={bollaStyles.recapiti}>
            <Text style={bollaStyles.recapitiNome}>C.R.G. Scavi e trasporti Sagl</Text>
            <Text>Via Livio 5, 6830 Chiasso (TI)</Text>
            <Text>Tel: +41 78 751 32 51 - email:info@crgscavi.ch</Text>
          </View>
          {numeroBolla && (
            <View style={bollaStyles.numeroBollaBox}>
              <Text style={bollaStyles.numeroBollaLabel}>N° BOLLA</Text>
              <Text style={bollaStyles.numeroBollaText}>{numeroBolla}</Text>
            </View>
          )}
        </View>

        <Text style={bollaStyles.title}>BOLLA DI LAVORO</Text>

        <View style={bollaStyles.section}>
          <View style={bollaStyles.row}>
            <Text style={bollaStyles.label}>Cliente</Text>
            <Text style={bollaStyles.value}>{cliente || '-'}</Text>
          </View>
          <View style={bollaStyles.row}>
            <Text style={bollaStyles.label}>Cantiere</Text>
            <Text style={bollaStyles.value}>{cantiere || '-'}</Text>
          </View>
          <View style={bollaStyles.row}>
            <Text style={bollaStyles.label}>Data</Text>
            <Text style={bollaStyles.value}>{fmtData(data)}</Text>
          </View>
        </View>

        <View style={bollaStyles.divider} />

        <View style={bollaStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Mezzi utilizzati</Text>
          <View style={bollaStyles.tableHeader}>
            <Text style={bollaStyles.col1}>Mezzo</Text>
            <Text style={bollaStyles.col2}>Ore</Text>
            <Text style={bollaStyles.col3}>KM</Text>
          </View>
          {mezzi.filter(m => m.veicoloId || m.label).map((m, i) => (
            <View key={i} style={bollaStyles.tableRow}>
              <Text style={bollaStyles.col1}>{m.label || '-'}</Text>
              <Text style={bollaStyles.col2}>{m.ore || '-'}</Text>
              <Text style={bollaStyles.col3}>{m.km || '-'}</Text>
            </View>
          ))}
        </View>

        <View style={bollaStyles.divider} />

        <View style={bollaStyles.section}>
          <View style={bollaStyles.row}>
            <Text style={bollaStyles.label}>Smaltimento materiale da scavo (m³)</Text>
            <Text style={bollaStyles.value}>{smaltimentoScavo || '-'}</Text>
          </View>
          <View style={bollaStyles.row}>
            <Text style={bollaStyles.label}>Smaltimento demolizione (m³)</Text>
            <Text style={bollaStyles.value}>{smaltimentoDemo || '-'}</Text>
          </View>
        </View>

        <View style={bollaStyles.divider} />

        <View style={bollaStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Prestazione</Text>
          <Text style={bollaStyles.prestazione}>{prestazione || '-'}</Text>
        </View>

        <View style={bollaStyles.divider} />

        <View style={bollaStyles.footerRow}>
          <View style={bollaStyles.footerCol}>
            <Text style={bollaStyles.footerLabel}>Nome autista</Text>
            <Text>{nomeAutista || '-'}</Text>
          </View>
          <View style={bollaStyles.footerCol}>
            <Text style={bollaStyles.footerLabel}>Firma cliente</Text>
            {firmaUrl
              ? <Image src={firmaUrl} style={bollaStyles.firmaImg} />
              : <Text style={{ color: '#999' }}>Non firmato</Text>
            }
            {nomeClienteFirma ? (
              <Text style={{ marginTop: 4, fontSize: 10 }}>{nomeClienteFirma}</Text>
            ) : null}
          </View>
        </View>
      </Page>

      <Page size="A4" style={bollaStyles.page2}>
        <Text style={bollaStyles.page2Title}>FOTO PESATA</Text>
        <Text style={bollaStyles.page2Subtitle}>{cantiere} — {fmtData(data)}</Text>
        <View style={bollaStyles.divider} />
        {fotoPesataUrl
          ? <Image src={fotoPesataUrl} style={bollaStyles.fotoPesataImg} />
          : (
            <View style={bollaStyles.fotoPesataBox}>
              <Text style={bollaStyles.fotoPesataNone}>Nessuna foto pesata allegata</Text>
            </View>
          )
        }
      </Page>
    </Document>
  );
}